import React from "react";
import Slider from "react-slick";
import "./css/HeroSlider.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import image1 from '../asset/Images/large-1.png'
import image2 from '../asset/Images/large-2.png'


const HeroSlider = () => {
  const navigate = useNavigate()
  const banners = [
    {
      type: "image",
      title: "LIN'S BISTRO: EXQUISITE CHINESE & THAI CUISINE",
      description: "Discover the finest Chinese and Thai dishes in town. From savory stir-fries to flavorful curries, our menu is crafted to delight your taste buds. Available for Dine-In, Take-Out, Curbside, or Delivery.",
      buttonText: "ORDER ONLINE",
      image: image1,
    },
    {
      type: "image",
      title: "PERFECT PLATTERS FOR EVERY OCCASION",
      description: "Hosting an event? Let Lin's Bistro cater your gathering with our mouth-watering Chinese and Thai platters. Ideal for parties, meetings, and special occasions.",
      buttonText: "Order Now",
      image: image2,
    },
    
  ];
  

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div className="hero-slider">
      <Slider {...settings}>
        {banners.map((banner, index) => (
          <div className="hero-slide" key={index}>
            <img src={banner.image} alt={banner.title} className="hero-image" />
            <div className="hero-content">
              <h1 className="hero-h1" >{banner.title}</h1>
              <p className="hero-description">{banner.description}</p>
              <button className="btn btn-outline-light"
              style={{
                borderColor:'green',
                backgroundColor:'green'
                
              }}
              
              onClick={() => navigate("/order")}>
                {banner.buttonText}
              </button>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HeroSlider;
